import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { useTranslation } from 'react-i18next';
import { type CreateCommunicationRequest } from '../../../schema/communication/CreateCommunicationRequestSchema.ts';
import { InputRenderRow } from './styled/InputRenderRow.tsx';

interface ICommunicationTypeStaticInputProps {
  communication: CreateCommunicationRequest | null | undefined;
  isNew: boolean | null | undefined;
}

export function CommunicationTypeStaticInput(
  props: ICommunicationTypeStaticInputProps,
) {
  const { communication, isNew } = props;

  const { t } = useTranslation();

  if (isNew) return null;
  if (!communication?.idTipoComunicazione) return null;

  return (
    <>
      <InputRenderRow
        borderTop
        title={t('communications.type-row', 'Tipo Comunicazione')}
        input={<strong>{communication?.communicationType?.codice}</strong>}
      />
      <VerticalSpace />
    </>
  );
}
